import React from "react";
import { useAssetsInventoryModel } from "../assetsInventoryModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useOrgModel } from "@/views/base/organization/orgModel";




export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAssetsInventoryModel();
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "盘点单号",
            fieldName: "stocktakingCode",
            span:4
        }, {
            type: SearchTypeEnum.Select,
            placeholder: "盘点结果",
            fieldName: "result",
            options: [{label:'盘盈',value:'盘盈'},{label:'盘亏',value:'盘亏'},{label:'相符',value:'相符'}],
            span:4
        }, {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "所属部门",
            fieldName: "department",
            span:4,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        },
    ]

    return (
        <YhPageHeader
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}